<template>
<el-dialog title="资料归档" :visible="ziliaoFlag" width="800px"   :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
  <div>
    <div>
      <el-table :data="ZLlist" ref="table" bordersize="mini" style="width: 100%" class="tableComent" highlight-current-row center border
      height="400"  >
      <el-table-column width="120" label="操作" fixed>
          <template slot-scope="scope">
            <div>
              <el-button  type="text" size="mini" @click="editClick(scope.row)">修改备注</el-button>
              <el-button type="text" size="mini"  @click="delFN(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="120" label="文件" fixed>
          <template slot-scope="scope">
            <div>
              <el-button  type="text" size="mini" @click="fujianClick(scope.row)">查看</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" min-width="150" label="备注"></el-table-column>
        <el-table-column prop="createTime" :formatter="dateTimeFormat"  width="170" label="上传时间"></el-table-column>
        <el-table-column prop="createUser" width="150" label="上传人"></el-table-column>
      </el-table>
    </div>
    <div style="margin: 20px 0;">
      <el-form  :inline="true"  class="demo-form-inline"  label-width="100px"  size="mini"  >
          <el-form-item label="文件：" class="item1" prop="handleRemark">
           <uploadFiles :fileArr.sync='fileArr' v-if="imgFlag" ></uploadFiles>
          </el-form-item>
          <el-form-item label="文件备注：" class="is-required"  >
            <el-input placeholder="" type="text" maxlength="100" v-model="remark" ></el-input>
          </el-form-item>
           <el-button type="primary" @click="addFN" >保存</el-button>
        </el-form>
    </div>
    <el-dialog  title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="lookImgFlag"
      append-to-body width="800px" center>
      <div style="text-align: right;">
        <div id="printMe"  ref="print">
          <el-image style="width: 100%;" :src="imgUrl" fit="contain"></el-image>
        </div>
      </div>
    </el-dialog>
    <el-dialog  title="修改备注" :close-on-click-modal="false" append-to-body :close-on-press-escape="false"  @close="XGflag = false"  :visible.sync="XGflag" width="400px" center>
      <div>
        <el-form  :inline="true"  class="demo-form-inline"  label-width="80px"  size="mini"  >
          <el-form-item label="备注" class="is-required" prop="remark">
            <el-input placeholder="" type="textarea" maxlength="100" v-model="XGremark" class="gjh"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="XGflag = false">取 消</el-button>
        <el-button type="primary" @click="saveFn()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog" >关闭</el-button>

  </span>
</el-dialog>
</template>
<script>
import { findOrderArchivedData, addOrderArchivedData, deleteOrderArchivedData, updateOrderArchivedData } from '@/api/newTMS'
import { emptyFn, encryption, dateTimeFormat } from '@/utils/util'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
export default {
  components: {
    uploadFiles
  },
  name: 'ziliaoguidang',
  props: {
    ziliaoFlag: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      ZLlist: [],
      remark: '',
      fileArr: [],
      lookImgFlag: false,
      imgUrl: '',
      imgFlag: true,
      XGflag: false,
      row: {},
      XGremark: ''

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.getList()
  },
  methods: {
    editClick (row) {
      this.row = row
      this.XGremark = row.remark
      this.XGflag = true
    },
    saveFn () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      updateOrderArchivedData({
        remark: this.XGremark, id: this.row.id
      }).then(res => {
        loading.close()
        this.getList()
        this.XGflag = false
        this.XGremark = ''
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    fujianClick (row) {
      if (this.isImage(row.url)) {
        this.lookImgFlag = true
        this.imgUrl = row.fileKeyUrl
      } else {
        window.open(row.fileKeyUrl)
      }
    },
    isImage (filename) {
      const extension = filename.split('.').pop().toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      return imageExtensions.includes(extension)
    },
    getList () {
      findOrderArchivedData({ orderId: this.rowData.orderId }).then(res => { this.ZLlist = res })
    },
    delFN (row) {
      this.$confirm('是否执行删除操作？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deleteOrderArchivedData({
          deleteAttachmentsIds: [row.id]
        })
          .then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList()
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      })
    },
    addFN () {
      if (this.fileArr.length == 0) {
        this.$alert('请选择文件', '系统提示')
        return
      }
      if (!this.remark) {
        this.$alert('请输入文件备注', '系统提示')
        return
      }
      let imgfile = new FormData()
      imgfile.append('params', JSON.stringify({
        orderId: this.rowData.orderId,
        remark: this.remark
      }))
      this.imgFlag = false
      imgfile.append('file', this.fileArr[0].raw)
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      addOrderArchivedData(imgfile).then(res => {
        loading.close()
        this.getList()
        this.fileArr = []
        this.remark = ''
        this.imgFlag = true
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    closeDialog () {
      this.$emit('update:ziliaoFlag', false)
    }
  }

}
</script>

<style scoped lang='less'>

</style>
